import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";

import Loadercomponent from "../../../../Componets/Loader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import Header from "../../../../Componets/Header";

import { get_material_request } from "../../../../Controllers/Purchases/MaterialRequests";

import { PrinterOutlined } from "@ant-design/icons";
import ReactToPrint from "react-to-print";
import { Button } from "antd";

const MaterialRequestView = () => {
  const { id } = useParams();
  let componentRef = useRef();

  const [details, setDetails] = useState({});
  const [loader, setLoader] = useState(false);

  const fetchData = async () => {
    try {
      setLoader(true);

      const response = await get_material_request({ id });

      if (response?.status) {
        setDetails(response?.data);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 10mm;
        }

        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `;

    document.head.appendChild(style);
}, []);

  return (
    <Header>
      <Loadercomponent loader={loader}>
        <ScrollWrapper>
          <div className="flex justify-center">
            <div className="w-[8.27in] text-right py-4">
              <ReactToPrint
                trigger={() => (
                  <Button
                    className="bg-white border rounded hover:border-green-500"
                    size="large"
                  >
                    A4 Print <PrinterOutlined />
                  </Button>
                )}
                content={() => componentRef}
              />
            </div>
          </div>
          <div className="flex justify-center"  ref={(el) => (componentRef = el)}>
            <div className="w-full max-w-5xl bg-white p-6">
              <div className="text-center mb-6">
                <h1 className="text-2xl font-semibold">Material Request</h1>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm mb-6">
                <div>
                  <p>
                    <strong>MR Number :</strong> {details?.number}
                  </p>

                  <p>
                    <strong>Date :</strong>{" "}
                    {moment(details?.date).format("DD-MM-YYYY")}
                  </p>

                  <p>
                    <strong>Priority :</strong>{" "}
                    {details?.priority === 0 ? "Normal" : "Urgent"}
                  </p>

                  <p>
                    <strong>Status :</strong>{" "}
                    {details?.request_status === 0 ? "Pending" : "Approved"}
                  </p>
                </div>

                <div>
                  <p>
                    <strong>Requested By :</strong>{" "}
                    {details?.requested_by?.name}
                  </p>

                  <p>
                    <strong>Email :</strong> {details?.requested_by?.email}
                  </p>

                  <p>
                    <strong>Created By :</strong> {details?.created_by?.name}
                  </p>
                </div>
              </div>

              <hr className="my-4" />

              <div className="mb-6">
                <h3 className="font-semibold text-lg mb-2">Site Details</h3>

                <p>
                  <strong>Site :</strong> {details?.site?.name}
                </p>

                <p>
                  <strong>Site Number :</strong> {details?.site?.number}
                </p>

                <p>
                  <strong>Manager :</strong> {details?.site?.manager}
                </p>

                <p>
                  <strong>Contact :</strong> {details?.site?.contact_number}
                </p>

                <p>
                  <strong>Address :</strong> {details?.site?.address}
                </p>

                <p>
                  <strong>GPS :</strong> {details?.site?.gps_coordinates}
                </p>
              </div>

              <div className="mb-6">
                <h3 className="font-semibold text-lg mb-2">Notes</h3>

                <p>{details?.notes || "N/A"}</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">
                  Requested Materials
                </h3>

                <table className="w-full border">
                  <thead>
                    <tr className="bg-black text-white">
                      <th className="p-2 text-left">S.No</th>
                      <th className="p-2 text-left">Material</th>
                      <th className="p-2 text-center">Quantity</th>
                      <th className="p-2 text-center">Unit</th>
                    </tr>
                  </thead>

                  <tbody>
                    {details?.details?.length > 0 ? (
                      details?.details?.map((item, index) => (
                        <tr key={index} className="border-b">
                          <td className="p-2">{index + 1}</td>

                          <td className="p-2">
                            {item?.material?.name || item?.name}
                          </td>

                          <td className="p-2 text-center">{item?.quantity}</td>

                          <td className="p-2 text-center">
                            {item?.unit?.name || item?.unit_name}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center p-4">
                          No materials found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default MaterialRequestView;
